// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyB7m7KGIIHim43bUPn8prsFno9znnarpx0',
  authDomain: 'mztry-a0cef.firebaseapp.com',
  projectId: 'mztry-a0cef',
  storageBucket: 'mztry-a0cef.firebasestorage.app',
  messagingSenderId: '789776705446',
  appId: '1:789776705446:web:f6285308aff749cce0d167',
  measurementId: 'G-6FHP12XR1T',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);